import { TableCell } from '@mui/material';
import { styled } from '@mui/material/styles';

import { TableSurface } from '../../UI/Surface';

export const Scroller = styled(TableSurface)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  '& .MuiTable-root': { minWidth: '640px' },
  '& .MuiTableRow-root.is-current': {
    backgroundColor: theme.palette.tokens.color.actionTint,
  },
  '& .MuiTableBody-root .MuiTableRow-root:last-of-type .MuiTableCell-root': {
    borderBottom: 0,
  },
}));

export const HeadCell = styled(TableCell)(() => ({
  whiteSpace: 'nowrap',
}));

export const BodyCell = styled(TableCell)(({ theme }) => ({
  ...theme.typography.body2,
  color: theme.palette.text.primary,
  verticalAlign: 'middle',
}));

export const MutedCell = styled(BodyCell)(({ theme }) => ({
  color: theme.palette.text.secondary,
}));

export const MoneyCell = styled(BodyCell)(({ theme }) => ({
  fontVariantNumeric: 'tabular-nums lining-nums',
  fontWeight: theme.palette.tokens.font.weightMedium,
  whiteSpace: 'nowrap',
}));

export const EmptyRow = styled(TableCell)(({ theme }) => ({
  ...theme.typography.body2,
  textAlign: 'center',
  color: theme.palette.text.secondary,
  padding: `${theme.palette.tokens.space[8]}px ${theme.palette.tokens.space[4]}px`,
  borderBottom: 0,
}));

export const CellSecondary = styled('span')(({ theme }) => ({
  display: 'block',
  ...theme.typography.caption,
  color: theme.palette.text.secondary,
}));

export const FooterCell = styled(TableCell)(({ theme }) => ({
  ...theme.typography.body2,
  fontWeight: theme.palette.tokens.font.weightMedium,
  color: theme.palette.text.primary,
  backgroundColor: theme.palette.tokens.color.surfaceHover,
  borderBottom: 0,
  fontVariantNumeric: 'tabular-nums lining-nums',
  whiteSpace: 'nowrap',
}));
